import { ApiError } from '@/lib/api-client'

/** Pure: the `prompt` string of a 428 confirmation-required API error, else null. */
export function confirmationPrompt(err: unknown): string | null {
  if (!(err instanceof ApiError) || err.status !== 428) return null
  const body = err.body as { prompt?: unknown } | undefined
  return typeof body?.prompt === 'string' ? body.prompt : 'Please confirm this action.'
}

/** Pure: best-effort human message from an ApiError body (`errors[0].error|message`, `error`, `message`). */
export function apiErrorMessage(err: unknown): string {
  if (!(err instanceof ApiError)) return err instanceof Error ? err.message : 'Unexpected error'
  const b = err.body as
    | { error?: unknown; message?: unknown; errors?: Array<{ error?: unknown; message?: unknown }> | string }
    | undefined
  const first = Array.isArray(b?.errors) ? b.errors[0] : undefined
  const candidate =
    first?.error ?? first?.message ?? b?.error ?? b?.message ?? (typeof b?.errors === 'string' ? b.errors : undefined)
  return typeof candidate === 'string' ? candidate : err.message
}
